export const onClickOutside = (element, callback) => {
    document.addEventListener("click", (e) => {
        if (!element.contains(e.target)) callback();
    });
};

export const transformToPixels = (value) => `${value}px`;

export const useHeaderScroll = ($element) => {
    let height = $element.clientHeight;
    let prevScrollPosition = window.scrollY;

    const handleHeaderScroll = () => {
        const currentScrollPosition = window.scrollY;

        if (currentScrollPosition === 0) {
            $element.classList.add("on-top");
            $element.classList.remove("active");
            $element.classList.remove("fixed");
            $element.classList.remove("transition");
        }

        if (prevScrollPosition <= currentScrollPosition) {
            // Scroll down
            $element.classList.remove("active");

            if (currentScrollPosition > height) {
                $element.classList.add("fixed");
                $element.classList.add("transition");
                setTimeout(() => {
                    $element.classList.remove("on-top");
                }, 10);
            }
        } else {
            // Scroll up
            if ($element.classList.contains("fixed")) {
                $element.classList.add("active");
            }
        }

        prevScrollPosition = currentScrollPosition;
    };

    return {
        handleHeaderScroll,
    };
};

export const setCookie = (cookieKey, cookieValue, expirationDays) => {
    let expiryDate = "";

    if (expirationDays) {
        const date = new Date();

        date.setTime(
            `${date.getTime()}${expirationDays || 30 * 24 * 60 * 60 * 1000}`
        );

        expiryDate = `; expiryDate=" ${date.toUTCString()}`;
    }

    document.cookie = `${cookieKey}=${cookieValue || ""}${expiryDate}; path=/`;
};

export const getCookie = (cookieKey) => {
    let cookieName = `${cookieKey}=`;

    let cookieArray = document.cookie.split(";");

    for (let cookie of cookieArray) {
        while (cookie.charAt(0) == " ") {
            cookie = cookie.substring(1, cookie.length);
        }

        if (cookie.indexOf(cookieName) == 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
};

export const getNormalizedTextContent = (value) => {
    if (!value) {
        return "";
    }

    return value.replace(/(\r\n|\n|\r)/gm, "").trim();
};

export const getFirstAlphabeticalLetter = (value) => {
    return value.match(/[a-zA-Z]/).pop();
};

export const scrollToElement = ($el, options = { offset: -16 }) => {
    const y = $el.getBoundingClientRect().top + window.scrollY + options.offset;

    window.scrollTo({ top: y, behavior: "smooth" });
};

export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent.toString()
    );
};

export const getFocusableElements = ($el) => {
    const focusable = $el.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );

    return {
        focusable,
        $first: focusable[0],
        $last: focusable[focusable.length - 1],
    };
};

export const useFocusTrap = ({ $el }) => {
    const { $first, $last } = getFocusableElements($el);

    const handleKeyDown = (e) => {
        if (e.key !== "Tab") {
            return;
        }

        if (e.shiftKey) {
            if (document.activeElement === $first) {
                e.preventDefault();

                $last.focus();
            }

            return;
        }

        if (document.activeElement === $last) {
            e.preventDefault();

            $first.focus();
        }
    };

    const setFocusTrap = () => {
        $el.addEventListener("keydown", handleKeyDown);
    };

    const removeFocusTrap = () => {
        $el.removeEventListener("keydown", handleKeyDown);
    };

    return {
        setFocusTrap,
        removeFocusTrap,
    };
};

export const inertElements = (elements = [], enable = true) => {
    if (!elements || elements.length === 0) {
        return;
    }

    if (enable === true) {
        elements.forEach(($el) => $el.setAttribute("inert", "true"));

        return;
    }

    elements.forEach(($el) => $el.removeAttribute("inert"));
};
